import { Box, Stack, Typography } from '@mui/material';
import { useRootTranslation } from 'utils/hooks';
import StatusPill from './StatusPill';

const rootT = 'drawers.tracksImportResolver';

type FieldLineProps = { label: string; value: string };

const FieldLine = ({ label, value }: FieldLineProps) => (
  <Box sx={{ display: 'flex', gap: 0.5 }}>
    <Typography variant="caption" sx={{ fontWeight: 700 }}>
      {`${label}:`}
    </Typography>
    <Typography variant="caption">{value}</Typography>
  </Box>
);

type ImportedTrackDataProps = {
  matched: boolean;
  lineNumbers: string;
  vendorLibrary: string;
  vendorTitle: string;
  use: string;
  duration: string;
};

const ImportedTrackData = ({
  matched,
  lineNumbers,
  vendorLibrary,
  vendorTitle,
  use,
  duration,
}: ImportedTrackDataProps) => {
  const t = useRootTranslation(rootT);

  return (
    <Stack gap={2}>
      <StatusPill matched={matched} />
      <FieldLine label={t('fields.row')} value={lineNumbers} />
      <FieldLine label={t('fields.library')} value={vendorLibrary} />
      <FieldLine label={t('fields.trackTitle')} value={vendorTitle} />
      <Box sx={{ display: 'flex', gap: 3 }}>
        <FieldLine label={t('fields.use')} value={use} />
        <FieldLine label={t('fields.duration')} value={duration} />
      </Box>
    </Stack>
  );
};

export default ImportedTrackData;
